import { ObjectFactory } from '@/config/objectFactory';
import { EventBus } from '@/main';
import { ToastEvent } from '@/types/event';
import { AddPaymentSourceRequest, ApiRequest, DeletePaymentSourceRequest,
    SetDefaultPaymentSourceRequest, VerifyPaymentSourceRequest } from '@/types/request';
import { ApiResponse } from '@/types/response';
import { CommonUtils } from '@/util/commonUtils';
import { MedTransGoConstants } from '@/util/constants';
import { IPaymentSourceService } from '../iPaymentSourceService';

export class PaymentSourceService implements IPaymentSourceService {

    public async getPaymentCustomer(baseURL: string, paymentCustomer?: string): Promise<ApiResponse<any>> {
        const memberProfile = ObjectFactory.getCacheService().getMemberInfo();
        const paymentCustomerId = paymentCustomer || memberProfile.paymentCustomerId;
        const apiRequest: ApiRequest = {
            baseURL,
            url: `${MedTransGoConstants.HTTP_URL_PAYMENT}/customers/${paymentCustomerId}`,
            loaderEvent: {
                show: true,
            },
        };
        const iHttpService = ObjectFactory.getHttpService();
        const response = await iHttpService.get<any>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        return response;
    }

    public async getListPaymentSource(paymentMethod: 'bank_account' | 'card', baseURL: string):
    Promise<ApiResponse<any>> {
    const paymentCustomerId = ObjectFactory.getCacheService().getMemberInfo().paymentCustomerId;
    const apiRequest: ApiRequest = {
        baseURL,
        url: `${MedTransGoConstants.HTTP_URL_PAYMENT}/customers/${paymentCustomerId}/${paymentMethod}`,
        loaderEvent: {
            show: true,
        },
    };
    const iHttpService = ObjectFactory.getHttpService();
    const response = await iHttpService.get<any>(apiRequest);
    if (response.success) {
        response.data.forEach((element: any) => {
            element.last4 = '**** ' + element.last4;
        });
    } else {
        CommonUtils.showError(response);
    }
    return response;
}

    public async setDefaultPaymentSource(paymentSource: string, baseURL: string): Promise<ApiResponse<any>> {
        const paymentCustomerId = ObjectFactory.getCacheService().getMemberInfo().paymentCustomerId;
        const setDefaultPaymentSourceRequest: SetDefaultPaymentSourceRequest = {
            customerId: paymentCustomerId as any,
            paymentSourceId: paymentSource,
        };
        const apiRequest: ApiRequest = {
            baseURL,
            url: `${MedTransGoConstants.HTTP_URL_DEFAULT_PAYMENT_SOURCE}`,
            data: setDefaultPaymentSourceRequest,
            loaderEvent: {
                show: true,
            },
        };
        const iHttpService = ObjectFactory.getHttpService();
        const response = await iHttpService.put<any>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: 'Your default payment source has been changed!',
                title: 'Success',
                varient: 'success',
                timeout: 2000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        } else {
            CommonUtils.showError(response);
        }
        return response;
    }

    public async addCustomerCreditCard(addPaymentSourceRequest: AddPaymentSourceRequest, baseURL: string):
    Promise<ApiResponse<any>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL,
            url: `${MedTransGoConstants.HTTP_URL_PAYMENT_SOURCE}`,
            data: addPaymentSourceRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<any>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_ADD_CREDIT_CARD'),
                title: 'Success!',
                timeout: 5000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        } else {
            CommonUtils.showError(response);
        }
        return response;
    }

    public async addACHCard(addPaymentSourceRequest: AddPaymentSourceRequest, baseURL: string):
    Promise<ApiResponse<any>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
        baseURL,
        url: `${MedTransGoConstants.HTTP_URL_PAYMENT_SOURCE}`,
        data: addPaymentSourceRequest,
        loaderEvent: {
            show: true,
        },
        };
        const response = await iHttpService.post<any>(apiRequest);
        if (response.success) {
        const toastEvent: ToastEvent = {
            message: CommonUtils.translateMessageCode('MSG_ADD_ACH_CARD'),
            title: 'Success!',
            timeout: 5000,
            varient: 'success',
        };
        EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        } else {
        CommonUtils.showError(response);
        }
        return response;
    }

    public async deletePaymentSource(baseURL: string, deletePaymentSourceRequest: DeletePaymentSourceRequest):
    Promise<ApiResponse<any>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL,
            url: `${MedTransGoConstants.HTTP_URL_PAYMENT_SOURCE}`,
            data: deletePaymentSourceRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.delete<any>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        return response;
    }

    public async verifyPaymentSource(baseURL: string, verifyPaymentSourceRequest: VerifyPaymentSourceRequest):
    Promise<ApiResponse<any>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL,
            url: `${MedTransGoConstants.HTTP_URL_VERIFY_PAYMENT_SOURCE}`,
            data: verifyPaymentSourceRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.put<any>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        return response;
    }
}
